<template>
  <v-menu
    offset-y
    nudge-bottom="6"
  >
    <template v-slot:activator="menu">
      <v-tooltip top>
        <template #activator="tooltip">
          <v-chip
            color="leaf primary--text"
            class="font-weight-medium mx-2 mb-3"
            v-on="{ ...tooltip.on, ...menu.on }"
          >
            {{ displayedValue }} <slot name="suffix" />
          </v-chip>
        </template>
        {{ tooltip }}
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item
        disabled
        class="shamrock white--text"
      >
        {{ prompt }}
      </v-list-item>
      <v-list-item
        v-for="(item, index) in itemsSorted"
        :key="index"
        :class="{ leaf: item === value }"
        @click="multiple ? undefined : $emit('update:value', item)"
      >
        <v-checkbox
          v-if="multiple"
          v-model="checkboxValue"
          :label="item.text || item"
          :value="item.value || item"
          hide-details
          class="mt-2 mb-1"
        />
        <v-list-item-title v-else>
          {{ item.text || item }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { sortBy } from 'lodash'

export default {
  name: 'ProjectMetaItem',
  props: {
    tooltip: {
      type: String,
      default: null
    },
    prompt: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    value: {
      type: [Array, String],
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemsSorted () {
      return sortBy(this.items, (item) => item.text || item)
    },
    checkboxValue: {
      get () { return this.value },
      set (val) {
        this.$emit('update:value', val)
      }
    },
    displayedValue () {
      if (Array.isArray(this.value)) {
        return this.value.join(', ') || 'none'
      }
      return this.value
    }
  }
}
</script>
